<main class="auth-handoff">
    <img
        class="auth-handoff-logo"
        src="assets/img/navbar/aiva_white.svg"
        alt="AIVA" />

    <ng-container *ngIf="state === 'loading'; else handoffError">
        <h1>Signing you in to AIVA 1.0</h1>
        <p>Please wait...</p>
        <div class="loader"></div>
    </ng-container>

    <ng-template #handoffError>
        <h1>We couldn't sign you in</h1>
        <p>
            The sign-in link may have expired or already been used. Return to
            AIVA and try switching again.
        </p>
        <button type="button" (click)="returnToAiva2()">
            Return to AIVA 2.0
        </button>
    </ng-template>
</main>
